import { CardSummary, CardGroup } from '@taxdown/kami-sama/dist/kamiSama';

export type SummaryCardProps = {
  hasIcon?: boolean;
  summaryCard: CardSummary;
  summaryCardGroup: CardGroup;
  deleteCard: (card: CardSummary) => void;
  editCard: (e: Event, card: CardSummary) => void;
};

export const defaultProps = {
  hasIcon: true,
};
